import { PledgeTransactionTypeEnum } from '@tassat/common-definitions';
import { FormModal } from '@tassat/modal';
import { convertToNumber } from '@tassat/utility';
import React from 'react';

import Worker from 'Lib/worker/PrimusWorker';
import { useAppSelector } from 'Reducers/store/hooks';
import { getAccountPositionsStatsByAccountId } from 'Selectors/accountPositions';
import { getSecurityCurrencyPairBySecurityTicker } from 'Selectors/assets';
import { getPledgeDetail, getUserId } from 'Selectors/common';

import AddOnForm from './addOnForm/addOnForm';
import { AddOnPledgeRequest, IAddOnFormValues } from './addOnForm/types';
import { PledgeContextWorkflowContext } from '../../../pledgeContextWorkflow';
import { ModalComponentProps } from '../../types';

function AddOn(props: ModalComponentProps) {
    const { pledgeContextWorkflowState, dispatchPledgeContextWorkflowAction } = React.useContext(PledgeContextWorkflowContext)!;
    const { accountId, selectedPledge } = pledgeContextWorkflowState;
    const pledgeDetail = useAppSelector(getPledgeDetail);

    const userId = useAppSelector(getUserId);
    const assetPair = useAppSelector((state) => getSecurityCurrencyPairBySecurityTicker(state, selectedPledge?.Ticker));
    const accountPositionBalance = useAppSelector((state) => {
        return getAccountPositionsStatsByAccountId(state, accountId);
    });

    const handleClose = () => {
        dispatchPledgeContextWorkflowAction({
            type: 'CHANGE_MODAL_SCREEN',
            payload: { screen: 'details' }
        });
    };

    const handleAddOn = async (values: IAddOnFormValues) => {
        if (!pledgeDetail || !assetPair.security?.Ticker) return;
        try {
            const createPledgeRequestValues: AddOnPledgeRequest = {
                UserId: userId,
                PledgorAccount: pledgeDetail.PledgingAccountAddress,
                Ticker: assetPair.security.Ticker,
                AssetQuantity: convertToNumber(values.AssetAmount),
                ApprovalNeeded: props.approvalNeeded,
                PledgeId: pledgeDetail.PledgeId
            };

            dispatchPledgeContextWorkflowAction({
                type: 'SET_MODAL_PLEDGE_VALUES',
                payload: {
                    PledgeId: createPledgeRequestValues.PledgeId,
                    AssetQuantity: createPledgeRequestValues.AssetQuantity,
                    Ticker: createPledgeRequestValues.Ticker,
                    PledgeParticipant: pledgeDetail.PledgeParticipant
                }
            });
            dispatchPledgeContextWorkflowAction({
                type: 'SET_PLEDGE_TYPE',
                payload: PledgeTransactionTypeEnum.pledge_add_on
            });
            dispatchPledgeContextWorkflowAction({
                type: 'CHANGE_MODAL_SCREEN',
                payload: { screen: 'details' }
            });
            dispatchPledgeContextWorkflowAction({
                type: 'SET_PLEDGE_ACTION_IN_PROGRESS',
                payload: true
            });
            await Worker.getInstance()
                .createPledgeRequest(createPledgeRequestValues);
        } catch (error) {
            console.error(error);
        }
    };

    const formData = {
        pledge: pledgeDetail,
        assetPair,
        accountPositionBalance,
        handleAddOn
    };

    return (
        <FormModal
            Form={AddOnForm}
            formProps={formData}
            formType='actionForm'
            modalWidth='40%'
            onClose={handleClose}
            open
            title='Add On'
        />
    );
}

export { AddOn };